import {
  defaultStep as DomainRegDefaultStep,
  pages as DomainRegPages,
} from "@/pages/ExternalPages/DomainReg";

export const flows = {
  "domain:add": {
    name: "domain-registration",
    defaultStep: DomainRegDefaultStep,
    pages: DomainRegPages,
  },
};

export const themeText = {
  storebuilder: {
    "switch-client-header": "Wait a second; can you double-check that?",
    "switch-client-description":
      "It looks like your Nexcess account and StoreBuilder don’t match!\nHere are some things to try:",
    "switch-client-name": "StoreBuilder",
    "error-header": "Something about logging into the correct StoreBuilder account.",
    "summary-description":
      'Congratulations! You have purchased your domain. Click "Return to StoreBuilder" to go back to your WP account where you can activate your site with your new domain.',
    "summary-return-button": "Return to StoreBuilder",
  },
};
